import React from 'react';
import { LineItem } from '../../../hooks/useCart/cart.rest';
import { Link } from '../../Link';
import { Image } from '../../Image';
import './LineItemImage.scss';

type Props = {
  item: LineItem;
};

export const LineItemImage: React.FC<Props> = ({
  item: {
    attributes: { variantHref, variantId, imageSrc, productName }
  }
}) => (
  <Link to={variantHref}>
    <Image
      className="LineItemImage__image"
      src={imageSrc}
      alt={productName}
      data-variant-pk={variantId}
      width="180"
      height="320"
    />
  </Link>
);
